import * as React from 'react'
import { DefaultHubColors } from '../interfaces';
import { pickTextColor } from '../utils/color_helpers';

type Props = {
  date: Date
  colorHex?: string;
}

const readableMonthFrom = (date: Date) => date.toLocaleDateString('en-NZ', {
  month: 'short',
} as Intl.DateTimeFormatOptions).toLocaleUpperCase();

const readableTimeFrom = (date: Date) => date.toLocaleTimeString('en-NZ', {
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
} as Intl.DateTimeFormatOptions);

const calendarSize = 56

const CalendarDate = ({ date, colorHex = DefaultHubColors.primary }: Props) => (
  <div className="CalendarDate grid grid-cols-1" style={{ width: calendarSize, height: calendarSize }}>
    <div data-testid="CalendarDate--dateBackground" className="rounded-t flex items-center justify-center" style={{ width: calendarSize, height: calendarSize / 3, backgroundColor: colorHex, color: pickTextColor(colorHex, 'white', 'black') }}>
      <span className="text-xs">{readableMonthFrom(date)}</span>
    </div>
    <div className="bg-white rounded-b flex items-center justify-center" style={{ width: calendarSize, height: calendarSize * 2 / 3 }}>
      <span className="text-black text-xl">{date.getDate()}</span>
    </div>
    <div className="flex justify-center">
      <span style={{ color: colorHex }}>{readableTimeFrom(date)}</span>
    </div>
  </div>
)

export default CalendarDate
